import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface FormSectionWrapperProps {
  children: JSX.Element;
  titleTid?: string;
  subtitleTid?: string;
  subtitleTidDynamicTexts?: string[];
}

export const FormSectionWrapper = ({
  children,
  titleTid,
  subtitleTid,
  subtitleTidDynamicTexts,
}: FormSectionWrapperProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} pb={2}>
      {titleTid && (
        <Font variant="h5" color="secondary">
          <Text tId={titleTid} />
        </Font>
      )}
      {subtitleTid && (
        <Font variant="body2" color="textSecondary" style={{ marginTop: '6px' }}>
          <Text tId={subtitleTid} dynamicDataTexts={subtitleTidDynamicTexts} />
        </Font>
      )}
      <Box display={'flex'} flexDirection={'column'} gridGap={26} pt={3}>
        {children}
      </Box>
    </Box>
  );
};
